import React, { useContext, useEffect, useState } from "react";
import "./Test.css";
import Questions from "../../imgs/questions.png";
import Time from "../../imgs/time.png";
import Notesex from "../../imgs/notesex.png";
import Submit from "../../imgs/submit.png";
import Gradelogo from "../../imgs/gradelogo.png";
import Language from "../../imgs/language.png";
import back from "../../imgs/back.png";
import perfor from "../../imgs/perfor.png";
import { Grade } from "@material-ui/icons";
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import Globalcontext from "../../Context/Globalcontext";
import { ToastContainer, toast } from 'react-toastify';
import Dialogmtestt from '../Dialogmtest/Dialogmtest';
import { useRef } from "react";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid } from 'recharts';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";

const Test = (props) => {

  const navigate = useNavigate();
  const notifyerror = (msg) => toast.error(msg);
  const notifysuccess = (msg) => toast.success(msg);
  const [grade, setGrade] = useState("");
  const [wait, setWait] = useState(false);
  const [showperfor, setShowperfor] = useState(false);
  const [language, setLanguage] = useState("");
  const [DataSource, setDataSource] = useState([]);
  const [input, setInput] = useState({ ayear: "", password: "" });
  const a = useContext(Globalcontext);
  const ref = useRef(null);
  const [data, setGdata] = useState([]);
  const refclose = useRef(null);

  const colors = ['#FF8042', '#FFBB28', 'pink', '#0088FE', '#00C49F', 'red'];


  const getPath = (x, y, width, height) => {
    return `M${x},${y + height}C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3}
  ${x + width / 2}, ${y}
  C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${x + width}, ${y + height}
  Z`;
  };

  const TriangleBar = (props) => {
    const { fill, x, y, width, height } = props;

    return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />;
  };

  useEffect(() => {

    if (props.testname === "Practice Test" || props.testname === "Main Test" || props.testname === "Demo Test") {

      if (localStorage.getItem("glstudentstatus") === "Free") {
        navigate('/plans');
      }
      else if (localStorage.getItem("glstudentstatus") === "Active") {
        setLanguage(localStorage.getItem('gllanguage'));
        setGrade(localStorage.getItem('glgrade'));
      }
    }
    else {
      setLanguage('');
      setGrade('');
    }
    if (localStorage.getItem("gllogin") === '') {
      navigate('/studentiqtest');
    }
  }, [props.testname])

  const handleChange = (event) => {
    // if (props.testname === "Demo Test") {
    //   if (event.target.name === "selectgrade") {
    //     setGrade(event.target.value);
    //   }
    //   else if (event.target.name === "selectlang") {
    //     setLanguage(event.target.value);
    //   }
    // }
  }

  const [Dialogmtest, setDialogmtest] = useState({
    message: "",
    isLoading: false,
    nameProduct: ""
  });

  const handlepause = (message, isLoading, nameProduct) => {
    setDialogmtest({
      message,
      isLoading,
      nameProduct
    });
  }

  const areUSure2 = (choose) => {
    if (choose) {
      handlepause("", false);
    } else {
      handlepause("", false);
    }
  };

  let rawData = {
    grade1: grade,
    language1: language,
    testname: props.testname,
    DataSource: DataSource,
    ayear: input.ayear
  }

  const toexam = () => {

    if (DataSource.length === 20) {
      navigate('/exam', { state: rawData });
      a.setStatus("started");

    }
    else {
      notifyerror("Network Error,Please try again!");
    }
  }

  useEffect(() => {
  
    if (DataSource != null && DataSource.length > 0) {
      toexam();
    }
  }, [DataSource]);

  const testcontainerVariants = {
    true: {
      marginLeft: '0px',
      width: '-webkit-calc(100vw - 14rem)'
    },
    false: {
      marginLeft: '-130px',
      width: '-webkit-calc(100vw - 6rem)',
      transition: {
        delay: 0.6
      }
    }
  }

  const testdescriVariants = {
    true: {
      width: '100%',
    },
    false: {
      width: '100%',
      transition: {
        delay: 0.6
      }
    }
  }

  const setresult = async () => {
    if (localStorage.getItem("glresult")) {
      const myobject = JSON.parse(localStorage.getItem("glresult"));

      const etime = JSON.parse(localStorage.getItem("gletime"));

      a.setMinutes(etime["minutes"]);
      a.setSeconds(etime["seconds"]);



      await setAsyncTimeout(() => {
        setcorrect(myobject[0]["optiona"], myobject[0]["correct"]);
      }, 40);

      await setAsyncTimeout(() => {
        setcorrect(myobject[1]["optiona"], myobject[1]["correct"]);
      }, 40);

      await setAsyncTimeout(() => {
        setcorrect(myobject[2]["optiona"], myobject[2]["correct"]);
      }, 40);

      await setAsyncTimeout(() => {
        setcorrect(myobject[3]["optiona"], myobject[3]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[4]["optiona"], myobject[4]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[5]["optiona"], myobject[5]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[6]["optiona"], myobject[6]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[7]["optiona"], myobject[7]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[8]["optiona"], myobject[8]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[9]["optiona"], myobject[9]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[10]["optiona"], myobject[10]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[11]["optiona"], myobject[11]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[12]["optiona"], myobject[12]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[13]["optiona"], myobject[13]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[14]["optiona"], myobject[14]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[15]["optiona"], myobject[15]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[16]["optiona"], myobject[16]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[17]["optiona"], myobject[17]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[18]["optiona"], myobject[18]["correct"]);
      }, 40);
      await setAsyncTimeout(() => {
        setcorrect(myobject[19]["optiona"], myobject[19]["correct"]);
      }, 40);

      if (a.correct <= 4) {
        a.setEstiscore(70);
      }
      else if (a.correct > 4 && a.correct <= 8) {
        a.setEstiscore(85);
      }
      else if (a.correct > 8 && a.correct <= 12) {
        a.setEstiscore(100);
      }
      else if (a.correct > 12 && a.correct <= 16) {
        a.setEstiscore(115);
      }
      else if (a.correct > 16 && a.correct <= 19) {
        a.setEstiscore(130);
      }
      else if (a.correct == 20) {
        a.setEstiscore(145);
      }


      const temptime = JSON.parse(localStorage.getItem("gletime"));

      a.setElminutes((30 - temptime.minutes) - 1);

      let rawData2 = {
        correct1: a.correct,
        anasweredtemp1: a.anasweredtemp,
        testname: props.testname,
        grade: grade,
        language: language,
        ayear: input.ayear,
        rand: localStorage.getItem("glrand"),
      }
      await setAsyncTimeout(() => {
        navigate('/Result', { state: rawData2 });
      }, 100);
    }

  }

  const setAsyncTimeout = (cb, timeout = 0) => new Promise(resolve => {
    setTimeout(() => {
      cb();
      resolve();
    }, timeout);
  });

  const setcorrect = (optiontemp, correcttemp) => {

    if (optiontemp !== undefined) {
      if (optiontemp !== "") {
        if (optiontemp === correcttemp) {
          a.setCorrect(a.correct++);
        }
      }
      else if (optiontemp == "") {
        a.setAnasweredtemp(a.anasweredtemp++);
      }
    }
    else {
      a.setAnasweredtemp(a.anasweredtemp++);
    }
  }

  useEffect(() => {
    setInput({ ayear: localStorage.getItem("ayear") });
  }, [])

  const startmaintest = async () => {
    getoldresult();

  }

  const getoldresult = () => {
    setWait(true);
    localStorage.setItem("glresult", "null");
    let rawData = {
      ayear: input.ayear,
      contact: localStorage.getItem("glmobno")
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData);

    axios.post('https://softtesting.in/iniqtest/cust/studentpanel/getoldresult.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {

      if (response.data.length > 0) {
        if (response.data && response.data.length) {
          response.data.map((user, index) => {

            localStorage.setItem('glresult', user.result);
            localStorage.setItem('gletime', user.etime);
            localStorage.setItem('glrand', user.rand);
            localStorage.setItem('glmaintest', user.maintest);
            localStorage.setItem('ayear', user.ayear);
            localStorage.setItem('gllogin', "true");
            a.setMainresult(JSON.parse(user.result));
          })

        }
        else {
          localStorage.setItem('glmaintest', "No");
        }
      }
      else {
        localStorage.setItem('glmaintest', "No");
      }
      setWait(false);
      getqset();


    }).catch(err => {
      console.log(err);
      setWait(false);
    });
  }

  const getoldresultdemo = async () => {
    console.log("in");
    setWait(true);
    localStorage.setItem("glresultdemo", "null");

    let rawData = {
      ayear: localStorage.getItem("ayear"),
      contact: localStorage.getItem("glmobno")
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData);

    axios.post('https://softtesting.in/iniqtest/cust/studentpanel/getoldresultdemopc.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(async function sample(response) {
     
      if (response.data.length > 0) {
        
        if (response.data && response.data.length) {
          response.data.map((user, index) => {
            localStorage.setItem('glresult', user.result);
            localStorage.setItem('gletime', user.etime);
            localStorage.setItem('glrand', user.rand);
            localStorage.setItem('glmaintest', user.maintest);
            localStorage.setItem('ayear', user.ayear);
            localStorage.setItem('gllogin', "true");
            a.setMainresult(JSON.parse(user.result));

          })

        }
        else {
          localStorage.setItem('glmaintest', "No");
        }
      }
      else {
        localStorage.setItem('glmaintest', "No");
      }
      //  getqset();
      setWait(false);

  
      if (localStorage.getItem("glresult")) {
        notifysuccess("Demo Test Conducted already before for Academic year " + input.ayear);
        await setAsyncTimeout(() => {
          setresult();
        }, 40);
      }
      else{
        //First Time Demo Test..

        setWait(true);
        const examname = "TEST FOR " + grade + "/" + props.testname + "/" + language;
        let rawData = {
          examtype: props.testname,
          examname: examname,
          grade: grade
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData);
  
        axios.post('https://softtesting.in/iniqtest/cust/studentpanel/tempqset.php', formData, {
          'Content-Type': 'multipart/form-data',
  
        }).then(function sample(response) {
          // var myArray_decoded = JSON.parse(jsEncode.encode(response.data, '123'));
          // setDataSource(myArray_decoded);
          // setWait(false);

          var myArray_decoded = JSON.parse(jsEncode.encode(response.data, '123'));
          a.setMainresult(myArray_decoded);
          setDataSource(myArray_decoded);
          setWait(false);

  
        }).catch(err => {
          console.log(err);
        });
      }

    }).catch(err => {
      console.log(err);
    });
  }

  const getqset = async () => {
    setWait(true);
    if (input.password === localStorage.getItem("glgrade2")) {

      if (localStorage.getItem("glresult") !== "null") {
        notifysuccess("Exam Conducted already before for Academic year " + input.ayear);
        await setAsyncTimeout(() => {
          setresult();
        }, 40);
      }
      else {
        notifysuccess("Exam started");
        const examname = "TEST FOR " + grade + "/" + props.testname + "/" + language;
        let rawData = {
          examtype: props.testname,
          examname: examname,
          grade: grade
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData);

        axios.post('https://softtesting.in/iniqtest/cust/studentpanel/tempqset.php', formData, {
          'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {

          var myArray_decoded = JSON.parse(jsEncode.encode(response.data, '123'));
          a.setMainresult(myArray_decoded);
         // console.log(myArray_decoded);
          setWait(false);

        }).catch(err => {
          console.log(err);
        });
      }
    }
    else {
      notifyerror("Invalid Password");
      setInput("");
      setWait(false);
    }
  }

  useEffect(() => {
    if (props.testname === "Main Test" || props.testname === "Demo Test" ) {
     
      if (localStorage.getItem("glmaintest") === "No" && localStorage.getItem("glmaintest") !== "") {

       
        if (localStorage.getItem("glresult") === "null") {
          if (JSON.stringify(a.mainresult) !== "[]") {
            let rawData = {
              mobno: localStorage.getItem("glmobno"),
              resultsend: JSON.stringify(a.mainresult),
              maintest: "No",
            }
            rawData = JSON.stringify(rawData)
            let formData = new FormData()
            formData.append('data', rawData);
            axios.post('https://softtesting.in/iniqtest/cust/studentpanel/updateresult2.php', formData, {
              'Content-Type': 'multipart/form-data',

            }).then(function sample(response) {
              setDataSource(a.mainresult);
            }).catch(err => {
              console.log(err);
            });
          }
        }
      }
    }
  }, [a.mainresult])

  const getquestions = () => {
    a.setexamtype(props.testname);

    if (props.testname === "Practice Test") {
      setWait(true);
      const examname = "TEST FOR " + grade + "/" + props.testname + "/" + language;
      let rawData = {
        examtype: props.testname,
        examname: examname,
        grade: grade
      }
      rawData = JSON.stringify(rawData)
      let formData = new FormData()
      formData.append('data', rawData);

      axios.post('https://softtesting.in/iniqtest/cust/studentpanel/tempqset.php', formData, {
        'Content-Type': 'multipart/form-data',

      }).then(function sample(response) {

        var myArray_decoded = JSON.parse(jsEncode.encode(response.data, '123'));
        setDataSource(myArray_decoded);
        setWait(false);

      }).catch(err => {
        console.log(err);
      });
    }
    else if (props.testname === "Demo Test") {
      getoldresultdemo();
    }
    else if (props.testname === "Main Test") {
      handlepause("Please Enter Password to start the Main Test", true, "");
    }
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = "";
      // make sure that input is string
      str = s.toString();
      for (var i = 0; i < s.length; i++) {
        // create block
        var a = s.charCodeAt(i);
        // bitwise XOR
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  const getmyperfor = () => {
    setGdata([]);
    let rawData = {
      contact: localStorage.getItem("glmobno"),

    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData);

    axios.post('https://softtesting.in/iniqtest/cust/studentpanel/getmyperfor.php', formData, {
      'Content-Type': 'multipart/form-data',

    }).then(function sample(response) {
      setGdata(response.data);

    }).catch(err => {
      console.log(err);
    });
  }

  const handlePerfor = (event) => {
    setShowperfor(true);
    getmyperfor();
  }
  const closeperfor = (event) => {
    setShowperfor(false);
  }

  return (

    <motion.div
      initial={`${props.open}`}
      animate={`${props.open}`}
      variants={testcontainerVariants}
      className="test">

      {showperfor ?
        < motion.div className="testdescri" initial={`${props.open}`}
          animate={`${props.open}`}
          variants={testdescriVariants}>
          <div className="performain">
            <div className="perforhead">
              <img onClick={closeperfor} className="smallimg" src={back} alt="" />
              <span className="head4">My IQ Performance </span>
              <span className="head4"> - {localStorage.getItem("glname")}</span>
            </div>

            <div className="bchart">
              {
                data.length > 0 ?

                  <BarChart
                    width={500}
                    height={300}
                    data={data}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Bar dataKey="uv" fill="#8884d8" shape={<TriangleBar />} label={{ position: 'top' }}>
                      {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={colors[index % 20]} />
                      ))}
                    </Bar>
                  </BarChart>

                  :
                  ""
              }
              <span className="head4">My Sections performance (Out of 100%)</span>
              <table id="table-to-xls" className="table-striped">
                <thead>
                  <tr>
                    <th className="tdfont" scope="col">Sr</th>
                    <th className="tdfont" scope="col">Year</th>
                    <th className="tdfont" scope="col">Critical Thinking</th>
                    <th className="tdfont" scope="col">Understanding</th>
                    <th className="tdfont" scope="col">Observations</th>
                    <th className="tdfont" scope="col">Logical</th>
                    <th className="tdfont" scope="col">Imagination</th>

                  </tr>
                </thead>
                <tbody>
                  {
                    data.map((user, index) =>
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{user.ayear}</td>
                        <td>
                          <div className="divrow">
                            {user.critical}%

                            <CircularProgressbar
                              styles={buildStyles({
                                textColor: "red",
                                pathColor: "#FF9800",
                                trailColor: "#D3D3D8",
                                fontSize: "9px"
                              })}
                              className='scoregrafftest' value={user.critical} text={user.critical} />
                          </div>
                        </td>
                        <td>
                          <div className="divrow">
                            {user.understanding}%

                            <CircularProgressbar
                              styles={buildStyles({
                                textColor: "red",
                                pathColor: "#FF9800",
                                trailColor: "#D3D3D8",
                                fontSize: "9px"
                              })}
                              className='scoregrafftest' value={user.understanding} text={user.understanding} />
                          </div>
                        </td>
                        <td >
                          <div className="divrow">
                            {user.observations}%
                            <CircularProgressbar
                              styles={buildStyles({
                                textColor: "red",
                                pathColor: "#FF9800",
                                trailColor: "#D3D3D8",
                                fontSize: "9px"
                              })}
                              className='scoregrafftest' value={user.observations} text={user.observations} />
                          </div>
                        </td>
                        <td>
                          <div className="divrow">
                            {user.logic}%
                            <CircularProgressbar
                              styles={buildStyles({
                                textColor: "red",
                                pathColor: "#FF9800",
                                trailColor: "#D3D3D8",
                                fontSize: "9px"
                              })}
                              className='scoregrafftest' value={user.logic} text={user.logic} />
                          </div>
                        </td>
                        <td >
                          <div className="divrow">
                            {user.imagination}%

                            <CircularProgressbar
                              styles={buildStyles({
                                textColor: "red",
                                pathColor: "#FF9800",
                                trailColor: "#D3D3D8",
                                fontSize: "9px"
                              })}
                              className='scoregrafftest' value={user.imagination} text={user.imagination} />
                          </div>
                        </td>

                      </tr>
                    )
                  }
                </tbody>
              </table>
            </div>




          </div>

        </motion.div>
        :
        <motion.div
          initial={`${props.open}`}
          animate={`${props.open}`}
          variants={testdescriVariants}
          className="testdescri">

          <div className="testname">
            <span className="head2">{props.testname}</span>
            <div onClick={handlePerfor} className="perfor">
              <img src={perfor} alt="" />
              <span className="head3">My IQ Performance</span>
            </div>
          </div>
          <div className="row">
            <img src={Questions} alt="" />
            <div className="verti">
              <span>20</span>
              <span>Questions</span>
            </div>
            <img src={Time} alt="" />
            <div className="verti">
              <span>30</span>
              <span>Minutes</span>
            </div>
          </div>

          <div className="instructions">
            <div className="inst">
              <img src={Notesex} alt="" />
              <span>Please Select Language and Class/Grade to start the Test.</span>
            </div>

            <div className="inst">
              <img src={Notesex} alt="" />
              <span>Tap Options to mark your answers.</span>
            </div>

            <div className="inst">
              <img src={Submit} alt="" />
              <span>
                Submit the test before 30 minutes else the test will submited
                automatically.
              </span>
            </div>
          </div>

          <div className="langclass">
            <div className="lang2">
              <img src={Gradelogo} alt="" />
              <select name="selectgrade" value={grade} onChange={handleChange} className="form-select" aria-label="Select Grade">
                <option defaultValue="Select Grade">Select Grade</option>
                <option value="CLASS - 1">CLASS - 1</option>
                <option value="CLASS - 2">CLASS - 2</option>
                <option value="CLASS - 3">CLASS - 3</option>
                <option value="CLASS - 4">CLASS - 4</option>
                <option value="CLASS - 5">CLASS - 5</option>
                <option value="CLASS - 6">CLASS - 6</option>
                <option value="CLASS - 7">CLASS - 7</option>
                <option value="CLASS - 8">CLASS - 8</option>
                <option value="CLASS - 9">CLASS - 9</option>
                <option value="CLASS - 10">CLASS - 10</option>
                <option value="CLASS - 11">CLASS - 11</option>
                <option value="CLASS - 12">CLASS - 12</option>
                <option value="Under Graduates">Under Graduates</option>
                <option value="Post Graduates">Post Graduates</option>
                <option value="Professionals">Professionals</option>

              </select>
            </div>
            <div className="lang2">
              <img src={Language} alt="" />
              <select name="selectlang" value={language} onChange={handleChange} className="form-select" aria-label="Select Grade">
                <option defaultValue="Select Language">Select Language</option>
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Marathi">Marathi</option>
              </select>
            </div>
          </div>

          <div className="startt">
            {
              wait ?
                <button >Loading..</button>
                :
                <button onClick={getquestions}>START TEST</button>
            }

          </div>
        </motion.div>
      }
      {
        Dialogmtest.isLoading && (
          <Dialogmtestt
            submessage={Dialogmtest.nameProduct}
            onDialog={areUSure2}
            message={Dialogmtest.message}
            functionname={startmaintest}
            setInput={setInput}
            input={input}
            button1text="START MAIN TEST"
            button2text="Cancel"
          />
        )
      }
    </motion.div >

  );
};

export default Test;
